const zhcn = {
  message: {
    searchpage: '搜索页',
    nickname: '请输入作品名称/作者昵称',
    search: '搜索',
    //totalworks:'相关共*个作品',
    total: '"相关共',
    relatedworks: '个作品',
    nomore: '没有更多了',
    votes: '票',
    loading: '加载中',
    nodata: '暂无数据',
    solicitation: '投票征集”欢迎投票！',
    popularityAward: '人气奖',

    activity_upload_works: {
      // videoSize:"若视频大小超过100M，请使用PC端上传",
      want_up: '我要报名',
      up_reg: '报名列表',
      sign_up: '本人报名',
      agent: '代报名',
      New_registration: '新增报名',
      up_once: '影像大赛为微视频参赛者提供版权音乐1首,支持并保证授权音乐作品已获得上游版权方完整授权。授权范围仅限本次大赛，参赛者不得将授权音乐作品用于授权项目以外的场景。若参赛选手违反本协议的约定使用授权音乐作品，所造成的纠纷由参赛选手自行承担，与影像大赛组委会无涉。',
      competition_area: '请选择对应赛区',
      Theme_of_the_work: '作品主题',
      Please_select_a_theme: '请选择作品主题',
      please: '上传前请先阅读',
      speak: '保障作品符合要求',
      realname: '真实姓名',
      pleasename: '请输入真实姓名',
      MP4_voide: '支持MP4格式视频',
      idnumber: '身份证号',
      pleaseID: '请输入作品作者真实身份证号',
      school: '学校/机构',
      please_school: '请输入学校全称，例：北京第二小学、上海市实验学校',
      pleadeenter: '请输入学校全称',
      contact: '联系方式',
      group: '组别',
      pleasegroup: '请选择组别',
      worktype: '作品类型',
      pleasetype: '请选择作品类型',
      worktitle: '作品标题',
      MP_voide: '支持MP4格式视频',
      pleasetitle: '请输入作品标题，30字以内',
      photography: '拍摄地点',
      Pleasephotographed: '请输入拍摄地点',
      description: '作品描述',
      pleasedescription: '请输入作品描述300字以内，输入前请点击投稿规则确认描述内容要求',
      descriptionworks: '请输入作品描述300字以内',
      Pleaseupload: '请上传作品文件',
      // imgroul:'1，图片原始尺寸不小于3M，压缩后尺寸为在2-10M。2，不得对原始图片进行技术合成、不得添加删减画面内容，不得过度调色加工，可适当进行裁剪和明暗度等基本调整。',
      imgroul: `文件须为<span
      style="color: #3360ff"
      >JPG</span
    >格式，长边不低于<span style="color: #3360ff">3000</span>像素，大小不小于<span
      style="color: #3360ff"
      >1M</span
    >，彩色、黑白不限，单幅、组照均可，组照图片数量应在<span style="color: #3360ff"
      >5至12</span
    >幅之间；`,
      opJPG: '请上传JPG格式文件',
      opscientific: '请上传科学制作作品',
      scworks: '科学制作',
      pleasephoto: '请按投稿规则上传5张作品图片',
      programming: '请上传创意编程作品',
      greative: '创意编程',
      plerasemp4: '请上传mp4格式视频',
      plworke: '请上传作品文件',
      plvideo: '请上传作品视频',
      mpgmov: 'mpg,mov这2种格式在此上传',
      upvideo: '上传视频',
      sub_des: '分说明',
      photo_tip: '请描述图片，100字以内',
      region: '赛区',
      clickcity: '点击选择赛区',
      byagree: '投稿即表示您同意',
      sprules: '权责说明',
      myagree: '我已经阅读并同意投稿协议',
      contribution: '投稿协议',
      con_Id: '我已确认作者本人真实的身份证信息',
      submit: '提交',
      work_infom: '作品信息',
      con_rules: '投稿规则',
      laseId: '身份证最后一位校验码不正确',
      onlucarry: '身份证仅能为15位或18位且前两位为有效行政区划代码',
      phone_null: '手机号码不能为空',
      phone_rules: '请输入正确格式的手机号码',
      Id_null: '身份证号不能为空',
      enter_id: '上传 mp4 格式视频',
      file_1g: '文件大小不能超过 1G',
      up_pic: '图文作品上传',
      up_videos: '视频作品上传',
      up_photo: '摄影作品上传',
      up_pain: '绘画作品上传',
      up_animation: '动漫作品上传',
      up_scientific: '科创作品上传',
      up_music: '音乐作品上传',
      up_work: '上传成功，作品待审核',
      prompt: '提示',
      up_failed: '上传失败，请检查作品',
      not_socket: '您的浏览器不支持socket',
      not_workes: '请勿上传重复作品!',
      complete: '请完整相关信息。',
      tick_id: '请勾选作者本人真实的身份证信息。',
      tick_privacy: '请勾选隐私协议。',
      work_name: '作者姓名',
      come_name: '请输入参赛者真实姓名',
      true_id: '请输入作品作者真实身份证号',
      select_region: '请选择赛区',
      click_region: '点击选择赛区',
      real_id: '我已确认作者本人真实的身份证信息',
      real_to_name: '确认报名',
      suc_reg: '报名成功',
      fail_reg: '报名失败，请稍后重试',
      please_rele: '请完整相关信息。',
      please_trueid: '请勾选作者本人真实的身份证信息',
      suc_select: '您已成功报名，请选择',
      mision_works: '作品投稿',
      activity_home: '活动首页',
      no_add: '暂无报名信息，快来添加吧',
      // photo_tip: '请输入图片描述',
      under_unview: '您已投稿，作品正在审核中'
    },
    //个人资料
    user: {
      profile: '个人资料',
      photo: '头像',
      alias: '昵称',
      gender: '性别',
      male: '男',
      female: '女',
      phonenumber: '手机号',
      pleasenumber: '请输入手机号',
      address: '邮寄地址',
      enterphone: '请输入手机号',
      submit: '提交',
      logout: '退出登录',
      phone_null: '手机号码不能为空',
      rulesph: '请输入正确格式的手机号码',
      logged: '已退出',
      sub_succ: '提交成功。',
      sub_later: '提交失败，请稍候重试。',
      com_mation: '请完整相关信息。',
      my: '我的',
      activity: '活动',
      News: '影像',
      journal: '画册',
      mywork: '我的作品',
      no_more: '没有更多了',
      ticket: '票',
      no_data: '暂无数据',
      my_crea: '我的证书',
      no_crea: '您还没有证书哦！',
      my_award: '我的获奖',
      no_award: '您还没有获奖哦！',
      download: '下载',
      share: '分享',
      copy_suc: '复制成功',
      copy_failed: '复制失败',
      message_list: '消息列表',
      no_have: '您还没有',
      oh: '哦'
    },
    explain: {
      txt_xon: '图文投稿',
      g_txt: '图文',
      voide_con: '视频投稿',
      voide: '视频',
      photo_con: '摄影投稿',
      photo: '摄影',
      pain_con: '绘画投稿',
      pain: '绘画',
      animation_con: '动漫投稿',
      animation: '动漫',
      scienfic: '科创投稿',
      sci_work: '科创',
      music: '音乐投稿',
      sci_music: '音乐'
    },
    explainTwo: {
      g_txt: '图文类',
      video: '视频类',
      photo: '摄影类',
      pain: '绘画类',
      animation: '动漫类',
      sci_work: '科创类',
      sci_music: '音乐类'
    },
    //我的
    my: {
      me: '我的',
      event: '活动',
      log: '请先登录',
      entry: '我的作品',
      prize: '我的获奖',
      certificate: '我的证书',
      messages: '消息通知',
      certification: '实名认证',
      logged: '您还未登录，请先登录。',
      award_tuned: '获奖作品开发中，敬请期待。',
      personalCertification: `
      <h4>签约条款 </h4>
      <h4>用户在申请和使用本系统时，必须遵守本用户协议。您只有完全接受以下所有服务条款后，才能继续注册申请手续。一旦您完成注册申请，本网可以认为您已经详细阅读并确认同意接受本用户协议的所有条款。</h4>
      <p>我承诺接受以下条款：</p>
      <p>一、用户在注册申请时自愿提供准确而详尽的个人资料，如个人资料有任何变动，必须及时更新；如果用户提供的个人资料不准确、不真实、不合法，本网保留结束用户使用本网各项服务的权利；由于用户提供的个人资料不准确、不真实、不合法所造成的损失，完全由用户本人承担；</p>
      <p>二、用户对所申请的帐号和密码安全负全部责任；本网尽量采取完备的网络安全措施，但是不能承担万一发生黑客攻击对用户造成的损失；用户若发现任何非法使用自己帐号或其它安全漏洞的情况，应立即通知本网；</p>
      <p>三、用户使用本网传输图文文件，须单方面承担对文件内容所应负的所有法律责任，包括核实影像内容的真实性，不侵犯他人肖像权和著作权等；</p>
      <p>四、本网保留随时修改或中断服务而不需通知用户的权利。用户接受本网行使修改或中断服务的权利，本网不需对用户或第三方负责；</p>
      <p>五、与本网签约的摄影师用户，本网有权将其图片介绍给使用客户。摄影师提供的图片，应符合本网所要求的技术参数，并应为每张图片提供符合本网标准的文字说明；</p>
      <p>六、摄影师用户授权本网拥有全球范围内的以下权利：有权从计算机硬盘、软盘、CD-ROM、数据库、网络服务器上编辑、储存用户图片；有权复制、展示和出售用户图片，并向各类国际互联网网站、报纸、杂志、广播电视、电子出版物以及其他现存和未来发展产生的的媒体提供相关的图片产品；有权制订用户图片的销售价格；有权批准和授权第三者使用上述权利；</p>
      <p>七、摄影师用户同意授权本网为在国际互联网上进行用户图片销售的唯一代理机构，即用户不得再将图片授权给其他与本网同样性质的网络图片代理机构使用，但仍拥有将图片直接出售给其他终端使用者的机构或个人的权利。若用户违反此条规定，本网有权单方解除本协议，本网同时保留向用户索赔经济损失的权利；</p>
      <p>八、摄影师用户同意在与本网解约后，本网不再享有唯一代理权，但仍有权存储和销售用户在本协议有效期间提供的图片的权利，并按原协议约定的条件向用户支付稿酬，同时用户亦可授权其他与本网同样性质的网络图片代理机构销售用户图片；</p>
      <p>九、摄影师用户保证对所提供的每张图片均拥有完整的合法的版权，用户图片不应涉及侵犯他人著作权、商标权、名誉权、隐私权及其它违法的内容。摄影师用户应对其所提供图片的违法内容所造成的一切后果承担相应的法律责任；</p>
      <p>十、如果发生第三人未经甲、乙任何一方授权而使用用户图片或其他对用户图片侵权的情形，则摄影师用户同意授权本网与第三方进行交涉；</p>
      <p>十一、为了扩大知名度，摄影师用户同意授权本网（“新摄荟”摄影平台，网址：http://zxp.mlyunai.com/）以及本网的所有权者免费使用并传播摄影师用户上传的图片的缩略图，鉴于目前网络未经同意转载图片缩略图的现象众多，摄影师用户同意放弃索取互联网上缩略图使用费的权利；</p>
      <p>十二、本网对摄影师实行累计付酬制，即按每张照片在本网被用户下载的次数多次付酬，但本网的所有权者可以在一次性付费的前提下，将摄影师用户提供的图片作为对外宣传通稿向海外播发；</p>
      <p>十三、本网拒绝向本网用户提供任何类型的担保；</p>
      <p>十四、用户承诺在使用本网提供的服务时，遵守所有适用于本网服务的地方法律、国家法律和国际法律。用户承诺：</p>
      <p>A、在本网的网页上发布信息或者利用本网的服务时必须符合中国有关法规，不得在本网的网页上或者利用本网的服务制作、复制、发布、传播以下信息：</p>
      <p>a) 反对宪法所确定的基本原则的；</p>
      <p>b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>c) 损害国家荣誉和利益的；</p>
      <p>d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>i) 含有法律、行政法规禁止的其他内容的。</p>
      <p>B、在本网的网页上发布信息或者利用本网的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
      <p>C、不利用本网的服务从事以下活动：</p>
      <p>a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
      <p>b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
      <p>c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
      <p>d) 故意制作、传播计算机病毒等破坏性程序的；</p>
      <p>e) 其他危害计算机信息网络安全的行为。</p>
      <p>D、不以任何方式干扰本网的服务。</p>
      <p>E、遵守本网的所有其他规定和程序。</p>
      <p>用户需对自己在使用本网服务过程中的行为承担法律责任。用户理解，如果本网发现其网站传输的信息明显属于上述第十四条A款所列内容之一，依据中国法律，本网有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。</p>
      <p>若用户的行为不符合以上提到的服务条款，本网将作出独立判断立即取消用户服务帐号。</p>
      <p>十五、用户或本网可随时根据实际情况中断服务。本网不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对本网服务不满，用户只有以下的追索权：</p>
      <p>a) 不再使用本网服务；</p>
      <p>b) 结束用户使用本网服务的资格；</p>
      <p>c) 通告本网停止该用户的服务。</p>
      <p>结束用户服务后，用户使用本网服务的权利马上中止。从那时起，本网不再对用户承担任何义务。</p>
      `,
      enterpriseCertification: `
      <h4>签约条款 </h4>
      <h4>用户在申请和使用本系统时，必须遵守本用户协议。您只有完全接受以下所有服务条款后，才能继续注册申请手续。一旦您完成注册申请，本网可以认为您已经详细阅读并确认同意接受本用户协议的所有条款。</h4>
      <p>我承诺接受以下条款：</p>
      <p>一、用户在注册申请时自愿提供准确而详尽的个人资料，如个人资料有任何变动，必须及时更新；如果用户提供的个人资料不准确、不真实、不合法，本网保留结束用户使用本网各项服务的权利；由于用户提供的个人资料不准确、不真实、不合法所造成的损失，完全由用户本人承担；</p>
      <p>二、用户对所申请的帐号和密码安全负全部责任；本网尽量采取完备的网络安全措施，但是不能承担万一发生黑客攻击对用户造成的损失；用户若发现任何非法使用自己帐号或其它安全漏洞的情况，应立即通知本网；</p>
      <p>三、用户使用本网传输图文文件，须单方面承担对文件内容所应负的所有法律责任，包括核实影像内容的真实性，不侵犯他人肖像权和著作权等；</p>
      <p>四、本网保留随时修改或中断服务而不需通知用户的权利。用户接受本网行使修改或中断服务的权利，本网不需对用户或第三方负责；</p>
      <p>五、与本网签约的摄影师用户，本网有权将其图片介绍给使用客户。摄影师提供的图片，应符合本网所要求的技术参数，并应为每张图片提供符合本网标准的文字说明；</p>
      <p>六、摄影师用户授权本网拥有全球范围内的以下权利：有权从计算机硬盘、软盘、CD-ROM、数据库、网络服务器上编辑、储存用户图片；有权复制、展示和出售用户图片，并向各类国际互联网网站、报纸、杂志、广播电视、电子出版物以及其他现存和未来发展产生的的媒体提供相关的图片产品；有权制订用户图片的销售价格；有权批准和授权第三者使用上述权利；</p>
      <p>七、摄影师用户同意授权本网为在国际互联网上进行用户图片销售的唯一代理机构，即用户不得再将图片授权给其他与本网同样性质的网络图片代理机构使用，但仍拥有将图片直接出售给其他终端使用者的机构或个人的权利。若用户违反此条规定，本网有权单方解除本协议，本网同时保留向用户索赔经济损失的权利；</p>
      <p>八、摄影师用户同意在与本网解约后，本网不再享有唯一代理权，但仍有权存储和销售用户在本协议有效期间提供的图片的权利，并按原协议约定的条件向用户支付稿酬，同时用户亦可授权其他与本网同样性质的网络图片代理机构销售用户图片；</p>
      <p>九、摄影师用户保证对所提供的每张图片均拥有完整的合法的版权，用户图片不应涉及侵犯他人著作权、商标权、名誉权、隐私权及其它违法的内容。摄影师用户应对其所提供图片的违法内容所造成的一切后果承担相应的法律责任；</p>
      <p>十、如果发生第三人未经甲、乙任何一方授权而使用用户图片或其他对用户图片侵权的情形，则摄影师用户同意授权本网与第三方进行交涉；</p>
      <p>十一、为了扩大知名度，摄影师用户同意授权本网（“新摄荟”摄影平台，网址：http://zxp.mlyunai.com/）以及本网的所有权者免费使用并传播摄影师用户上传的图片的缩略图，鉴于目前网络未经同意转载图片缩略图的现象众多，摄影师用户同意放弃索取互联网上缩略图使用费的权利；</p>
      <p>十二、本网对摄影师实行累计付酬制，即按每张照片在本网被用户下载的次数多次付酬，但本网的所有权者可以在一次性付费的前提下，将摄影师用户提供的图片作为对外宣传通稿向海外播发；</p>
      <p>十三、本网拒绝向本网用户提供任何类型的担保；</p>
      <p>十四、用户承诺在使用本网提供的服务时，遵守所有适用于本网服务的地方法律、国家法律和国际法律。用户承诺：</p>
      <p>A、在本网的网页上发布信息或者利用本网的服务时必须符合中国有关法规，不得在本网的网页上或者利用本网的服务制作、复制、发布、传播以下信息：</p>
      <p>a) 反对宪法所确定的基本原则的；</p>
      <p>b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>c) 损害国家荣誉和利益的；</p>
      <p>d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>i) 含有法律、行政法规禁止的其他内容的。</p>
      <p>B、在本网的网页上发布信息或者利用本网的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
      <p>C、不利用本网的服务从事以下活动：</p>
      <p>a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
      <p>b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
      <p>c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
      <p>d) 故意制作、传播计算机病毒等破坏性程序的；</p>
      <p>e) 其他危害计算机信息网络安全的行为。</p>
      <p>D、不以任何方式干扰本网的服务。</p>
      <p>E、遵守本网的所有其他规定和程序。</p>
      <p>用户需对自己在使用本网服务过程中的行为承担法律责任。用户理解，如果本网发现其网站传输的信息明显属于上述第十四条A款所列内容之一，依据中国法律，本网有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。</p>
      <p>若用户的行为不符合以上提到的服务条款，本网将作出独立判断立即取消用户服务帐号。</p>
      <p>十五、用户或本网可随时根据实际情况中断服务。本网不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对本网服务不满，用户只有以下的追索权：</p>
      <p>a) 不再使用本网服务；</p>
      <p>b) 结束用户使用本网服务的资格；</p>
      <p>c) 通告本网停止该用户的服务。</p>
      <p>结束用户服务后，用户使用本网服务的权利马上中止。从那时起，本网不再对用户承担任何义务。</p>
      `,
      myNews: '我的影像',
      manuscript: '篇稿件',
      signingCertification: '签约认证',
      submissionTime: '上架时间',
      previewPending: '待初审',
      reviewPending: '待复审',
      finalReviewPending: '待终审',
      finalReviewPassed: '终审通过',
      finalReviewRejected: '审核未通过',
      backTip: '退回的稿件，修改后可重新上传'
    },
    //分享-首页-活动作品页-活动详情-作品详情
    home: {
      yuanjing: '元景云摄影大赛平台',
      p_yuanjing: '大千视界，元景相伴',
      china_yuanjing: '欢迎参加“影像中国”影像大赛！',
      home_page: '首页',
      Feedback: '问题反馈',
      i_all: '全部',
      i_pro: '进行中',
      t_start: '待开始',
      ended: '已结束',
      partic: '  已有*人参与',
      signed: '  已有*人报名',
      dsy_rema: '剩余*天',
      m: '我的',
      votes: '票',
      Vote: '投票',
      VoteAss: '投票助力',
      Voted: '已投票',
      coll: '作品正在收集中',
      b_top: '返回顶部',
      latest: '最新',
      pop_works: '热门',
      allreg: '全部赛区',
      entry_ready: '您已经给该作品投过票',
      succ_vote: '投票成功',
      network: '请检查网络',
      log_first: '请先登录',
      event_start: '活动未开始',
      event_ended: '活动已结束',
      first_log: '您还未登录，请先登录。',
      work_con: '最新',
      work_conTwo: '活动作品',
      Introduction: '简介',
      IntroductionTwo: '活动简介',
      Award_works: '获奖',
      List_of_Organizations: '榜单',
      contribute: '我要投稿',
      txt_works: '图文作品',
      php_works: '摄影作品',
      voide_works: '视频作品',
      pain_works: '绘画作品',
      animation: '动漫作品',
      scientific_works: '科创作品',
      event_details: '活动详情',
      prize_information: '奖项信息',
      prize_details: '奖品信息',
      event_not: '活动还未开始',
      evetn_start: '活动已经结束',
      event_reg: '活动赛区',
      Relatedlist: '关联榜单',
      surplus: '剩余',
      days: '天',
      Solicitation: '征集',
      to: '至',
      total: '共',
      participated: '人参与',
      Tovote: '去投票',
      entry_details: '作品详情',
      up_on: '上传于',
      works_in: '该作品正在参加',
      enter: '进入',
      next_group: '下一组',
      share: '分享',
      click_friend: '点击右上角分享即可发送给朋友哦',
      my_know: '知道啦',
      voted_entry: '您已经给该作品投该过票。',
      unlike: '取消点赞',
      liked_suc: '点赞成功',
      next_not: '暂无下一条',
      function_start: '功能开发中',
      onlyvotes10: '每人最多投10票,只可投一次',
      list: '榜单',
      submit_vote: '提交投票',
      voting_tips: '活动已结束，暂不支持投票',
      organizationIntroduction: '机构简介',
      organizationNoInformation: '该机构暂无简介信息'
    },
    //入围获奖通知
    awarded: {
      registration: '入围作品信息登记表',
      au_name: '作者姓名',
      gender: '性别',
      age: '年龄',
      school_name: '学校/机构名称',
      Division: '赛区',
      group: '组别',
      Telephone: '电话',
      address: '地址',
      Company: '快递公司',
      odd_num: '单号',
      sub_suc: ' 提交成功',
      winning: '获奖作者信息登记表',
      select: '请选择',
      Category: '作品类别',
      please_enter: '请输入',
      correct: ' 请输入正确手机号!',
      name_work: '作品名称',
      one_three: '小学低年级组(1-3年级)',
      si_liu: '小学高年级组(4-6年级)',
      groub_one: '初中组',
      groub_two: '高中组',
      activity_name: '活动名称'
    },
    login: {
      lo_reg: '登录/注册',
      select_log_reg: '选择登录/注册方式',
      log_num: '使用手机号登录/注册',
      log_wet: '使用微信登录/注册',
      agree_read: '我已阅读并同意使用协议及',
      privacy: '隐私政策',
      check_agree: '请勾选隐私协议。',
      log_phone: '手机号登录',
      log_pass: '密码登录',
      please_phone: '请输入手机号',
      enter_code: '请输入验证码',
      please_pass: '请输入密码',
      pass_null: '密码不能为空',
      new_pass_null: '新密码8-20位，必须包含数字小写字母',
      correct_phone: '请输入正确格式的手机号码',
      sent_succ: '发送成功，请注意查收',
      resend: '重新发送',
      failed_send: '发送失败',
      ver_code: '请输入验证码.',
      reg_suc_log: '注册成功，请重新登录',
      please_com: '请完整相关信息。',
      no_pass: '两次密码不一致',
      sign: '登录',
      account_reg: '没有账号？去注册',
      forget_pass: '忘记密码',
      send_code: '发送验证码',
      phone_null: '手机号码不能为空',
      login_suc: '登录成功',
      page_jump: '页面跳转中',
      num_reg: '手机号注册',
      en_pass: '请输入含英文和数字的8-16位密码',
      name_plase: '请输入昵称',
      name_null: '昵称不能为空',
      acc_reg: '账号注册',
      pain_again: '请再次输入密码',
      chang_suc: '修改密码成功',
      rest_pass: '重置密码',
      register: '注册',
      agreement: {
        texts: `
    <h4>影像大赛网络服务使用协议 </h4>
    <h4>Photography Contest Network Service Agreement</h4>
    <p>1. 特别提示</p>
    <p>1. Special Reminder</p>
    <p>1.1 本网站举办的影像大赛同意按照本协议的规定及其不时发布的操作规则提供基于互联网以及移动网相关服务（以下称"网络服务"）。为获得网络服务，服务使用人（以下称"用户"）同意遵守本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意"按钮即表示用户完全接受本协议项下的全部条款。</p>
    <p>1.1 The Photography Contest held by this website (hereinafter "Contest") will follow the provisions of this Agreement and the operation rules published from time to time to provide relevant services based on the Internet and mobile network (hereinafter "Network Service"). To obtain Network Service, the service user (hereinafter "User") agrees to abide by all clauses of this Agreement and complete the entire registration as per the prompts on this page. During registration, clicking "Yes" means to totally accept all clauses hereunder.</p>
    <p>1.2 用户注册成功后，影像大赛将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。</p>
    <p>1.2 Upon successful registration, the Contest will give each User an account and relevant password which shall be kept by User; and User shall be responsible for all activities and incidents of his/her account.</p>
    <p>2. 服务内容</p>
    <p>2. Service Content</p>
    <p>2.1 大赛网络服务的具体内容由影像大赛根据实际情况提供，例如搜索、资讯、分享、竞赛和活动等。</p>
    <p>2.1 The Network Service includes specifically the contents provided by the Contest based on actual conditions, such as search, news, sharing, competition and events.</p>
    <p>2.2 用户理解，影像大赛仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行负担。</p>
    <p>2.2 User understands that the Contest provides only relevant Network Service and other than that, the equipment relating thereto (such as personal computer, other devices relating to the access of the Internet or mobile network) and the expenses needed (such as the phone bill and network fee paid for the Internet access) shall be borne by User.</p>
    <p>3. 服务变更、中断或终止</p>
    <p>3. Change, Interruption or Termination of Service</p>
    <p>3.1 鉴于网络服务的特殊性，用户同意影像大赛有权随时变更、中断或终止部分或全部的网络服务。如变更、中断或终止的网络服务属于免费网络服务，影像大赛无需通知用户，也无需对任何用户或任何第三方承担任何责任。</p>
    <p>3.1 Given the special characteristics of Network Service, User agrees that the Contest is entitled to change, interrupt or terminate the Network Service by whole or by part at any time. If the Network Service so changed, interrupted or terminated is free, the Contest needs to send no further notice to User and bears no responsibility to any User or third party.</p>
    <p>3.2 用户理解，影像大赛需要定期或不定期地对提供网络服务的平台（如互联网网站）或相关的设备进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断，影像大赛无需为此承担任何责任，但影像大赛应尽可能事先进行通告。</p>
    <p>3.2 User understands that the Contest needs to check or maintain the platform providing the Network Service (such as the Internet website) or relevant equipment on a regular or irregular basis. In the event of any interruption thereof within a reasonable period due to the aforesaid causes, the Contest shall bear no responsibility in this regard provided that a prior notice shall be made public thereby as far as possible.</p>
    <p>3.3 如发生下列任何一种情形，影像大赛有权随时中断或终止向用户提供本协议项下的网络服务而无需对用户或任何第三方承担任何责任：</p>
    <p>3.3 In the event of any of the following circumstances, the Contest may interrupt or terminate at any time the Network Service provided hereunder without bearing any responsibility to User or any third party:</p>
    <p>3.3.1 用户提供的个人资料不真实；</p>
    <p>3.3.1 User provides untruthful personal information;</p>
    <p>3.3.2 用户违反本协议中规定的使用规则；</p>
    <p>3.3.2 User violates the rules of usage provided herein;</p>
    <p>4. 使用规则</p>
    <p>4. Rules of Usage</p>
    <p>4.1 用户在申请使用影像大赛网络服务时，必须向影像大赛提供准确的个人资料，如个人资料有任何变动，必须及时更新。</p>
    <p>4.1 User, when applying to use the Network Service of the Contest, must provide accurate personal information thereto and shall timely update such in the event of any change.</p>
    <p>4.2 用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知影像大赛。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，影像大赛不承担任何责任。</p>
    <p>4.2 User shall refrain from transferring or lending the account and password to others. User shall notify the Contest immediately upon discovery of any illegal usage of his/her account. The Contest shall be exempted from bearing any responsibility in the event of any illegal usage of the account and password due to hacking behavior or negligent maintenance by User.</p>
    <p>4.3 用户必须同意接受影像大赛通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。</p>
    <p>4.3 User must agree to receive product promotion or other relevant commercial information sent by the Contest via email or other methods.</p>
    <p>4.4 用户对于其通过影像大赛网络服务上传到影像大赛网站上的作品依法享有版权或版权合法授权及模特肖像权授权、物权授权等其他相关合法权利。用户应同意并遵守以下约定：</p>
    <p>4.4 User is entitled to the copyright or legal authorization of copyright, authorization of the right of portrait of model, authorization of property rights and other relevant lawful rights as to the works uploaded to the website via the Network Service. User shall agree and abide by the following provisions:</p>
    <p>4.4.1 对于用户上传的作品，用户仍保留原有的全部权利；</p>
    <p>4.4.1 User reserves all the original rights to uploaded works;</p>
    <p>4.4.2 影像大赛有权将作品缩略图等使用于本社区以及用户展示、推广的目的，包含但是不限于影像大赛、第三方网站、网络搜索结果、可嵌入代码、印刷品；</p>
    <p>4.4.2 The Contest may use thumbnail or other forms of works for the purpose of display or promotion in its community and among Users, including but not limited to the Contest, third-party websites, network search results, embeddable code and printed materials;</p>
    <p>4.4.3 影像大赛将采用行业内认可的软件和措施，用以限制其他用户或浏览者未经许可任意复制高清晰度的作品。但影像大赛无法保证未经用户许可，其上传的作品不会被他人非法复制。影像大赛不会限制其他用户或浏览者复制网站中的低清晰度作品或缩略图，对此用户应同意并给予影像大赛相应授权；</p>
    <p>4.4.3 The Contest will adopt the software and measures recognized by the industry to restrict other Users or visitors from unauthorized duplication of any high-definition works. However, the Contest can't guarantee that the uploaded works will not be copied by other illegally without the approval of User. The Contest will not restrict other Users or visitors from copying the works in low definition or thumbnails and for that, User shall agree and grant relevant authorization to the Contest;</p>
    <p>4.4.4 用户保证拥有完全的民事行为能力签署本协议，并有权作出本协议项下对影像大赛的授权。</p>
    <p>4.4.4 User shall ensure that he/she has full capacity for civil conduct to sign this Agreement and is entitled to make the authorization hereunder.</p>
    <p>4.5 用户在使用影像大赛网络服务过程中，必须遵循以下原则：</p>
    <p>4.5 During the usage of Network Service, User must abide by the following principles:</p>
    <p>4.5.1 遵守中国有关的法律和法规；</p>
    <p>4.5.1 Abide by relevant laws and regulations of China;</p>
    <p>4.5.2 遵守所有与网络服务有关的网络协议、规定和程序；</p>
    <p>4.5.2 Abide by all network protocols, rules and procedures relating to Network Service;</p>
    <p>4.5.3 不得为任何非法目的而使用网络服务系统；</p>
    <p>4.5.3 Refrain from using the Network Service system for any illegal purposes;</p>
    <p>4.5.4 不得利用影像大赛网络服务系统进行任何可能对互联网正常运转造成不利影响的行为；</p>
    <p>4.5.4 Refrain from using the Network Service system to conduct any activity which may affect the normal operation of the Internet and cause an unfavorable influence;</p>
    <p>4.5.5 不得利用影像大赛提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</p>
    <p>4.5.5 Refrain from using the Network Service to upload, exhibit or communicate any fake, harassing, slandering, abusive, threatening, vulgar, obscene or other illegal information materials;</p>
    <p>4.5.6 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权、肖像权、隐私权、物权或其他任何合法权益；</p>
    <p>4.5.6 Refrain from infringing upon the patent right, copyright, trademark right, right of reputation, right of portrait, right of privacy, property right or any other legal right and interest of any third party;</p>
    <p>4.5.7 不得利用影像大赛网络服务系统进行任何不利于影像大赛的行为；</p>
    <p>4.5.7 Refrain from using the Network Service system to conduct any activity against the Contest;</p>
    <p>4.5.8 如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告影像大赛。</p>
    <p>4.5.8 Notify the Contest immediately of any spotted illegal usage of account or security vulnerability.</p>
    <p>4.6 不得使用刷票软件等对投稿作品进行欺骗性恶意刷票。</p>
    <p>4.6 User shall refrain from conducting any fraudulent or malicious ballot rigging using relevant software.</p>
    <p>4.7 如用户在使用网络服务时违反任何本协议规定，影像大赛或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。</p>
    <p>4.7 If User violates any provision hereof when using the Network Service, the Contest or its authorized person may demand correction or take direct and necessary measures (including but not limited to changing or deleting the contents posted by User, pausing or terminating User's access to the Network Service User) to alleviate the consequences therefrom.</p>
    <p>4.8 影像大赛针对某些特定的影像大赛网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件、短信提醒等）作出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等影像大赛网络服务，视为用户同意该等声明、通知、警示的内容。</p>
    <p>4.8 Any declaration, notice, warning and other contents made by the Contest regarding certain specific usage of the Network Service via different channels (including but not limited to web page announcement, email, SMS, etc.) shall be deemed as a part of this Agreement. The usage of the Network Service by User shall constitute as User's consent to such declaration, notice or warning.</p>
    <p>4.9 用户有权随时将上传的作品删除，影像大赛也可删除任何违反本协议规定的作品。在收到用户提交的删除申请后，影像大赛将在合理期限内删除展示在任何第三方网站上的该用户作品。</p>
    <p>4.9 User may delete his/her uploaded work at any time and the Contest may delete any work violating this Agreement. Upon receiving the deletion request submitted by User, the Contest will delete the work in question on any displayed third-party websites within a reasonable period.</p>
    <p>4.10 影像大赛有权将用户上传的作品同步上传至cnsphoto.com中国影像图片网，且中国影像图片网可对作品进行点赞和收藏操作。</p>
    <p>4.10 The Contest is entitled to upload simultaneously the works uploaded by User to CNS Photo (cnsphoto.com) where such works may be liked and added to favorites.</p>
    <p>5. 知识产权</p>
    <p>5. Intellectual Property Rights</p>
    <p>5.1 影像大赛提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。影像大赛不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向用户或任何第三方负责。</p>
    <p>5.1 Any text, picture, graph, audio and/or video material contained in the Network Service is protected by copyright, trademark and/or other property ownership rights. Without the approval of relevant right holders, the aforesaid materials shall not be released, broadcasted, adapted or republished for the purpose of broadcast or release, directly or indirectly, or be used for other commercial purposes. All such materials or any part thereof may only be stored on a computer for personal and non-commercial purposes. The Contest shall not be liable to any User or third party for any delay, inaccuracy, error and omission incurred during generation, transmission or delivery of the aforesaid materials, in part or in whole, or any compensation generated therein or therefrom, of any form.</p>
    <p>5.2 影像大赛为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。</p>
    <p>5.2 All rights of the software (including but not limited to any picture, photo, animation, video, recording, music, text, additional program and supplementary guiding materials contained therein) used by the Contest to provide the Network Service shall belong to the copyright holder thereof. Without the approval thereof, User may not conduct any reverse engineering, decompilation or disassembling.</p>
    <p>5.3 用户保证其上传的作品不得侵犯或违反第三方的版权、专利权、商标权、商业秘密、隐私权、名誉权、肖像权、物权、公开权或其它知识产权或专有权利。</p>
    <p>5.3 User shall guarantee that the works he/she uploaded are in no violation or infringement of any copyright, patent right, trademark right, trade secret, right of privacy, right of reputation, right of portrait, right of property, right of publicity and other IPRs or exclusive rights of any third party.</p>
    <p>6. 隐私保护</p>
    <p>6. Privacy Protection</p>
    <p>6.1 保护用户隐私是影像大赛的一项基本政策，影像大赛保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在影像大赛的非公开内容，但下列情况除外：</p>
    <p>6.1 Protecting user privacy is a basic policy of the Contest and the Contest guarantees that it will not disclose to the public or any third party the registration materials of any User or any non-public content stored when User is using the Network Service, except for the following conditions:</p>
    <p>6.1.1 事先获得用户的明确授权；</p>
    <p>6.1.1 An explicit authorization has been obtained from User in advance;</p>
    <p>6.1.2 根据有关的法律法规要求；</p>
    <p>6.1.2 As required by relevant laws and regulations;</p>
    <p>6.1.3 按照相关政府主管部门的要求；</p>
    <p>6.1.3 As required by relevant government authorities;</p>
    <p>6.1.4 为维护社会公众的利益；</p>
    <p>6.1.4 To maintain the interests of the social public;</p>
    <p>6.1.5 为维护影像大赛的合法权益。</p>
    <p>6.1.5 To maintain the lawful rights and interests of the Contest.</p>
    <p>6.2   影像大赛可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与影像大赛同等的保护用户隐私的责任，则影像大赛有权将用户的注册资料等提供给该第三方。</p>
    <p>6.2 The Contest may work with third parties to provide relevant Network Services. In such event, the Contest may provide the registration materials and other contents of User for such third parties should they agree to bear the same responsibility for protecting User privacy as the Contest.</p>
    <p>6.3 在不透露单个用户隐私资料的前提下，影像大赛有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
    <p>6.3 Without disclosing the private materials of any User, the Contest may analyze and exploit in a commercial sense the entire database of user information.</p>
    <p>7. 免责声明</p>
    <p>7. Disclaimer</p>
    <p>7.1 用户明确同意其使用影像大赛网络服务所存在的风险将完全由其自己承担；因其使用影像大赛网络服务而产生的一切后果也由其自己承担，影像大赛对用户不承担任何责任。</p>
    <p>7.1 User explicitly agrees that all risks from using the Network Service will be borne on his/her own; any and all consequences generated from using the Network Service will be borne on his/her own and the Contest bears no responsibility in this regard.</p>
    <p>7.2 影像大赛不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</p>
    <p>7.2 The Contest will not guarantee definite satisfaction of Network Service to the needs of User nor will it guarantee the non-interruption, timeliness, security and accuracy of such Service.</p>
    <p>7.3 影像大赛不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由影像大赛实际控制的任何网页上的内容，影像大赛不承担任何责任。</p>
    <p>7.3 The Contest will not ensure the accuracy and completeness of the external links set for the convenience of User and meanwhile, and will bear no responsibility as to the contents on any page beyond the actual control of the Contest as directed by such external links.</p>
    <p>7.4 对于因不可抗力或影像大赛不能控制的原因造成的网络服务中断或其它缺陷，影像大赛不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p>
    <p>7.4 Interruption or other flaws of the Network Service incurred due to force majeure or reasons beyond the control of the Contest, the Contest will bear no responsibility in this regard but shall try its best to reduce the losses and influences of User caused therefrom.</p>
    <p>7.5 用户同意，对于影像大赛向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，影像大赛无需承担任何责任；</p>
    <p>7.5 User agrees that the Contest shall not bear any responsibility as to any loss caused by or related to the quality defects of the following product or service provided thereby;</p>
    <p>7.5.1 影像大赛向用户免费提供的各项网络服务；</p>
    <p>7.5.1 Different Network Services provided for User for free by the Contest;</p>
    <p>7.5.2 影像大赛向用户赠送的任何产品或者服务。</p>
    <p>7.5.2 Any product or service presented free of cost by the Contest.</p>
    <p>8. 违约赔偿</p>
    <p>8. Responsibility of Default</p>
    <p>8.1 如因影像大赛违反有关法律、法规或本协议项下的任何条款而给用户造成损失，影像大赛同意承担由此造成的损害赔偿责任。</p>
    <p>8.1 The Contest agrees to compensate for any loss of User caused by the violation of the Contest of any provision under relevant laws and regulations or this Agreement.</p>
    <p>8.2 用户同意保障和维护影像大赛及其他用户的利益，如因以下情形给影像大赛及其关联方或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任（包括但不限于律师费用、诉讼费、仲裁费及其他合理费用）：</p>
    <p>8.2 User agrees to safeguard and maintain the interests of the Contest and other Users, and to bear relevant responsibility for compensation (including but not limited to lawyer fee, litigation expense, arbitration fee and other reasonable costs) as to the loss of the Contest and its related parties or any other third person due to the following conditions:</p>
    <p>8.2.1 用户或使用用户帐号的其他人违反有关法律、法规或本协议项下的任何条款；</p>
    <p>8.2.1 User or other person using User's account violates any provision under relevant laws and regulations or this Agreement;</p>
    <p>8.2.2 任何第三人主张作品侵犯、盗用或违反其版权、商标权、专利权、商业秘密、隐私权、名誉权、公开权、肖像权、物权或其它知识产权或专有权利。</p>
    <p>8.2.2 Any third person lodges the claim against infringement, theft or violation of his/her copyright, trademark right, patent right, trade secret, right of privacy, right of reputation, right of publicity, right of portrait, property right or other IPRs or exclusive rights.</p>
    <p>9. 协议修改</p>
    <p>9. Modification of Agreement</p>
    <p>9.1 影像大赛有权随时修改本协议的任何条款，一旦本协议的内容发生变动，影像大赛将会通过适当方式向用户提示修改内容。</p>
    <p>9.1 The Contest is entitled to modify any provision of this Agreement at any time and once this Agreement is modified, the Contest will notify User of such modification in proper manners.</p>
    <p>9.2 如果不同意影像大赛对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受影像大赛对本协议相关条款所做的修改。</p>
    <p>9.2 User may stop the usage of Network Service if he/she disagrees with relevant modifications made. The continuous usage of Network Service will be deemed as acceptance of relevant modifications made.</p>
    <p>10. 通知送达</p>
    <p>10. Delivery of Notice</p>
    <p>10.1 本协议项下影像大赛对于用户所有的通知均可通过网页公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
    <p>10.1 All notifications made to User hereunder may be transmitted by web page announcement, email or regular mail delivery; such notifications will be deemed as delivered on the date of sending.</p>
    <p>10.2 用户对于影像大赛的通知应当通过影像大赛对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
    <p>10.2 Notification of User shall be transmitted to relevant correspondence address, fax number or email officially published by the Contest.</p>
    <p>11. 法律管辖</p>
    <p>11. Legal Jurisdiction</p>
    <p>11.1 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。</p>
    <p>11.1 The laws of China shall apply to the conclusion, execution and interpretation of this Agreement as well as the settlement of dispute, which shall all be subject to the jurisdiction of people's court in China.</p>
    <p>11.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向影像大赛所在地的人民法院提起诉讼。</p>
    <p>11.2 Any dispute concerning the content or its execution hereof shall be settled by amicable negotiation between both parties; where negotiation fails, either party may bring it to the people's court of the location of the Content.</p>
    <p>12. 其他规定</p>
    <p>12. Miscellaneous</p>
    <p>12.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
    <p>12.1 This Agreement constitutes the complete agreement of both parties concerning the issues agreed and other relevant matters mentioned herein. Other than this Agreement, no other rights are conferred to either party.</p>
    <p>12.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
    <p>12.2 Should any provision hereof become completely or partly invalid or non-executable due to whatever cause, the remaining provisions shall remain effective and binding.</p>
    <p>12.3 本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
    <p>12.3 Titles of this Agreement are set for convenience only and shall be neglected during interpretation.</p>`,
        agreement_title: '影像大赛网络服务使用协议',
        agreement_title1: 'Photography Contest Network Service Agreement',
        one: '1. 特别提示',
        h1n1: '1.1 本网站举办的影像大赛同意按照本协议的规定及其不时发布的操作规则提供基于互联网以及移动网相关服务（以下称"网络服务"）。为获得网络服务，服务使用人（以下称"用户"）同意遵守本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意"按钮即表示用户完全接受本协议项下的全部条款。',
        h1n2: '1.2 用户注册成功后，影像大赛将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。',
        two: '2. 服务内容',
        h2n1: '2.1 大赛网络服务的具体内容由影像大赛根据实际情况提供，例如搜索、资讯、分享、竞赛和活动等。',
        h2n2: '2.2 用户理解，影像大赛仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行负担。',
        three: '3. 服务变更、中断或终止',
        h3n1: '3.1 鉴于网络服务的特殊性，用户同意影像大赛有权随时变更、中断或终止部分或全部的网络服务。如变更、中断或终止的网络服务属于免费网络服务，影像大赛无需通知用户，也无需对任何用户或任何第三方承担任何责任。',
        h3n2: '3.2 用户理解，影像大赛需要定期或不定期地对提供网络服务的平台（如互联网网站）或相关的设备进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断，影像大赛无需为此承担任何责任，但影像大赛应尽可能事先进行通告。',
        h3n3: '3.3 如发生下列任何一种情形，影像大赛有权随时中断或终止向用户提供本协议项下的网络服务而无需对用户或任何第三方承担任何责任：',
        h3n3s1: '3.3.1 用户提供的个人资料不真实；',
        h3n3s2: '3.3.2 用户违反本协议中规定的使用规则；',
        four: '4.使用规则',
        h4n1: '4.1 用户在申请使用影像大赛网络服务时，必须向影像大赛提供准确的个人资料，如个人资料有任何变动，必须及时更新。',
        h4n2: '4.2 用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知影像大赛。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，影像大赛不承担任何责任。',
        h4n3: '4.3 用户必须同意接受影像大赛通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。',
        h4n4: '4.4 用户对于其通过影像大赛网络服务上传到影像大赛网站上的作品依法享有版权或版权合法授权及模特肖像权授权、物权授权等其他相关合法权利。用户应同意并遵守以下约定：',
        h4n4s1: '4.4.1 对于用户上传的作品，用户仍保留原有的全部权利；',
        h4n4s2: '4.4.2 影像大赛有权将作品缩略图等使用于本社区以及用户展示、推广的目的，包含但是不限于影像大赛、第三方网站、网络搜索结果、可嵌入代码、印刷品；',
        h4n4s3: '4.4.3 影像大赛将采用行业内认可的软件和措施，用以限制其他用户或浏览者未经许可任意复制高清晰度的作品。但影像大赛无法保证未经用户许可，其上传的作品不会被他人非法复制。影像大赛不会限制其他用户或浏览者复制网站中的低清晰度作品或缩略图，对此用户应同意并给予影像大赛相应授权；',
        h4n4s4: '4.4.4 用户保证拥有完全的民事行为能力签署本协议，并有权作出本协议项下对影像大赛的授权。',
        h4n5: ' 4.5 用户在使用影像大赛网络服务过程中，必须遵循以下原则：',
        h4n5s1: '4.5.1 遵守中国有关的法律和法规；',
        h4n5s2: '4.5.2 遵守所有与网络服务有关的网络协议、规定和程序；',
        h4n5s3: '4.5.3 不得为任何非法目的而使用网络服务系统；',
        h4n5s4: '4.5.4 不得利用影像大赛网络服务系统进行任何可能对互联网正常运转造成不利影响的行为；',
        h4n5s5: '4.5.5 不得利用影像大赛提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；',
        h4n5s6: '4.5.6 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权、肖像权、隐私权、物权或其他任何合法权益；',
        h4n5s7: '4.5.7 不得利用影像大赛网络服务系统进行任何不利于影像大赛的行为；',
        h4n5s8: '4.5.8 如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告影像大赛。',
        h4n6: '4.6 不得使用刷票软件等对投稿作品进行欺骗性恶意刷票。',
        h4n7: '4.7 如用户在使用网络服务时违反任何本协议规定，影像大赛或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。',
        h4n8: '4.8 影像大赛针对某些特定的影像大赛网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件、短信提醒等）作出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等影像大赛网络服务，视为用户同意该等声明、通知、警示的内容。',
        h4n9: '4.9 用户有权随时将上传的作品删除，影像大赛也可删除任何违反本协议规定的作品。在收到用户提交的删除申请后，影像大赛将在合理期限内删除展示在任何第三方网站上的该用户作品。',
        h4n10: '4.10 影像大赛组织方有权将用户上传的作品同步上传至cnsphoto.com中国影像图片网，用于展示、出售，中国影像图片网视为签约摄影师作品，如有第三方采用，支付相应稿费。',
        five: '5.知识产权',
        h5n1: '5.1 影像大赛提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。影像大赛不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向用户或任何第三方负责。',
        h5n2: '5.2 影像大赛为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。',
        h5n3: '5.3 用户保证其上传的作品不得侵犯或违反第三方的版权、专利权、商标权、商业秘密、隐私权、名誉权、肖像权、物权、公开权或其它知识产权或专有权利。',
        h5n4: '5.4 对用户上传的作品应用区块链等数字技术实现登记、存证等功能，提供独立、第三方的查询与验证服务。',
        six: '6. 隐私保护',
        h6n1: '6.1 保护用户隐私是影像大赛的一项基本政策，影像大赛保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在影像大赛的非公开内容，但下列情况除外：',
        h6n1s1: '6.1.1 事先获得用户的明确授权；',
        h6n1s2: '6.1.2 根据有关的法律法规要求；',
        h6n1s3: '6.1.3 按照相关政府主管部门的要求；',
        h6n1s4: '6.1.4 为维护社会公众的利益；',
        h6n1s5: '6.1.5 为维护影像大赛的合法权益。',
        h6n2: '6.2 影像大赛可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与影像大赛同等的保护用户隐私的责任，则影像大赛有权将用户的注册资料等提供给该第三方。',
        h6n3: '6.3 在不透露单个用户隐私资料的前提下，影像大赛有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。',
        h6n4: '6.4 您确认并同意授权“元景云”平台或以“元景云”平台自己的名义或委托专业第三方对侵犯您上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，“元景云”平台有权对维权事宜做出决策并独立实施。',
        seven: '7. 免责声明',
        h7n1: '7.1 用户明确同意其使用影像大赛网络服务所存在的风险将完全由其自己承担；因其使用影像大赛网络服务而产生的一切后果也由其自己承担，影像大赛对用户不承担任何责任。',
        h7n2: '7.2 影像大赛不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。',
        h7n3: '7.3 影像大赛不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由影像大赛实际控制的任何网页上的内容，影像大赛不承担任何责任。',
        h7n4: '7.4 对于因不可抗力或影像大赛不能控制的原因造成的网络服务中断或其它缺陷，影像大赛不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。',
        h7n5: '7.5 用户同意，对于影像大赛向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，影像大赛无需承担任何责任；',
        h7n5s1: '7.5.1 影像大赛向用户免费提供的各项网络服务；',
        h7n5s2: '7.5.2 影像大赛向用户赠送的任何产品或者服务。',
        eight: '8. 违约赔偿',
        h8n1: '8.1 如因影像大赛违反有关法律、法规或本协议项下的任何条款而给用户造成损失，影像大赛同意承担由此造成的损害赔偿责任。',
        h8n2: ' 8.2 用户同意保障和维护影像大赛及其他用户的利益，如因以下情形给影像大赛及其关联方或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任（包括但不限于律师费用、诉讼费、仲裁费及其他合理费用）：',
        h8n2s1: '8.2.1 用户或使用用户帐号的其他人违反有关法律、法规或本协议项下的任何条款；',
        h8n2s2: ' 8.2.2 任何第三人主张作品侵犯、盗用或违反其版权、商标权、专利权、商业秘密、隐私权、名誉权、公开权、肖像权、物权或其它知识产权或专有权利。',
        nine: '9.协议修改',
        h9n1: '9.1 影像大赛有权随时修改本协议的任何条款，一旦本协议的内容发生变动，影像大赛将会通过适当方式向用户提示修改内容。',
        h9n2: '9.2 如果不同意影像大赛对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受影像大赛对本协议相关条款所做的修改。',
        ten: '10. 通知送达',
        h10n1: '10.1 本协议项下影像大赛对于用户所有的通知均可通过网页公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。',
        h10n2: '10.2 用户对于影像大赛的通知应当通过影像大赛对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。',
        eleven: '11. 法律管辖',
        h11n1: '11.1 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。',
        h11n2: '11.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向影像大赛所在地的人民法院提起诉讼。',
        twelve: '12. 其他规定',
        h12n1: '12.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。',
        h12n2: '12.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。',
        h12n3: ' 12.3 本协议中的标题仅为方便而设，在解释本协议时应被忽略。'
      }
    },
    cpn: {
      have: '已有',
      people: '人参与',
      peop_come: '人报名',
      notice: '公告',
      cancel: '取消',
      // coll_works: '作品征集',
      coll_works: '征集',
      all_activity: ' 全部活动',
      nick_work: '请输入作者昵称/作品名称',
      more_division: '更多 ▼',
      away_all: '收起全部 ▲',
      head_portrait: '头像',
      be_work: '作品正在收集中~',
      no_con: '暂无内容',
      voted: '您已经给该作品投过票.',
      please_log: '请先登录',
      not_activity: '活动还未开始。',
      end_activity: '活动已结束',
      of_work: '作品投稿',
      bution: '投稿',
      expand_all: '展开全部',
      sponsor: '主办方信息',
      real_total: '相关共',
      works: '个作品',
      entrance: '进入'
    },
    txtpop: {
      h4: '权责说明',
      res_p1: ' 1.投稿作品不得侵犯他人的著作权、肖像权、名誉权、隐私权。若有第三方对作品中的人、建筑或其他事物提出权利方面的声明或不满，投稿者应对作品引发或可能引发的法律事务承担全部责任。',
      res_p2: ' 2.对于足以妨害公序良俗的作品及行为，一经发现将取消入选资格。“妨害公序良俗的作品及行为”包括但不限于可能严重误导公众认知、具有欺诈性质等一切违反法律、道德、公共秩序或善良风俗的情形。',
      res_p3: '  3.本次活动不收取任何费用，不设退稿。投稿作品仍由作者保留对作品的各项权利，活动组织方和征稿平台拥有作品在本次征集活动宣传范围内非商业用途使用权。著作权归作者所有，投稿作品将授予主办方及关联单位机构用于推广宣传活动，通过各种渠道（包括但不限于网络、影像发布或其他媒体、线下展示推广等活动）使用作品，使用时将保留作者署名权，使用时间三年，使用地域不受限制，允许主办方对（摄影类、科创类编程）作品进行修改和裁切等。',
      res_p4: '4.参赛者一旦上传作品，即视为同意并遵守以上规则。凡不符合征稿要求的作品，一律取消参赛资格。',
      res_p5: '5.本次活动最终解释权归主办方所有.',
      res_p6: '五、注意事项',
      res_p7: ' 1．参评者注册与填写信息须真实有效，并保持通讯畅通。主办方将通过电话和邮箱两种方式与入围作品参评者联系，要求参评者在指定日期内提供相关资料，逾期者视为自愿放弃。.',
      res_p8: ' 2．因奖品获得者未能提供准确的信息资料而导致未能收到相应稿酬、获奖证书的，责任由获奖者本人负责。.'
    },
    // 影像
    news: {
      pageTitle: '影像',
      searchPlaceholder: '影像标题/影像内容/影像作者',
      backHomepage: 'Return to the first page',
      toMy: '跳转我的',
      wantContribute: '我要投稿',
      contributeNews: '影像投稿',
      expandAll: '全部展开',
      putAway: '收起',
      author: '作者',
      Photograph: '摄',
      // publishedOn: '发布于',
      publishedOn: '发布时间',

      allChannels: '全部频道',
      realnameTip: '您未进行实名认证，暂不支持影像投稿，请点击去认证进行实名认证',
      toCrtification: '去认证',
      pictureNet: '图片网',
      tabList: [
        '推荐',
        '时政',
        '科教',
        '经济',
        '文化',
        '体育',
        '社会',
        '军事',
        '大赛',
        '自然',
        '国际',
        '漫画',
        '港澳台',
        '历史',
        '人物',
        '创意',
        '中新社'
      ],
      cpnTabList: [
        '推荐',
        '时政',
        '科教',
        '经济',
        '文化',
        '体育',
        '社会',
        '军事',
        '大赛',
        '自然',
        '国际'
      ],
      cpnMoreTabList: ['漫画', '港澳台', '历史', '人物', '创意', '中新社'],
      PictureName: '图片名称',
      whole: '全部',
      authorName: '作者姓名',
      authorNamePlaceholder: '请输入投稿者真实姓名',
      Headlines: '影像标题',
      HeadlinesPlaceholder: '请输入影像标题，30字以内',
      newsDetails: '影像描述',
      newsDetailsFontSize: '（1000字以内）',
      newsDetailsPlaceholder: '请输入影像描述内容，如时间，影像摘要',
      filmingLocations: '拍摄地点',
      PleaseChooseTheCity: '请选择城市',
      personalInformation: '个人信息',
      newsInformation: '影像信息',
      characterTag: '人物标签',
      characterPlaceholder: '请输入画面中的知名人物姓名',
      keywordTags: '关键词标签',
      keywordPlaceholder: '请输入关键词标签，用多个逗号隔开',
      groupPhotoNotes: '组图备注',
      groupPhotoNotesPlaceholder: '请输入组图备注',
      authorizeToTheGalleryToEarnRevenue: '授权到图库赚取收益',
      pleaseUploadNewsPictures: '请上传影像图片',
      supportedFormats: '支持jpg/png格式，不超过10M，支持批量上传',
      submitTip: '上传成功，稿件待审核',
      albumContribution: '图集投稿',
      reviewPending: '审核中',
      personalCertification: '个人认证',
      individualFunction: '个人用户开通影像投稿功能',
      provideAuthentication: '提供身份证/护照信息进行实名认证',
      enterpriseCertification: '企业认证/组织认证',
      enterpriseFunction: '企业/组织/机构用户开通新闻投稿功能',
      provideOrganization: '提供组织信息进行实名认证',
      pleaseType: '请选择认证类型',
      applyAgain: '再次申请',
      reviewPassed: '审核通过',
      personalSigningInformation: '个人签约认证失败，请选择一种类型重新上传认证信息',
      Signed: '已签约',
      applyNow: '立即申请',
      iDCard: '身份证',
      clickIDCard: '点击拍摄身份证人像面',
      realName: '真实姓名',
      identified: '待识别',
      iDNumber: '身份证号',
      idFrontalView: require('../../../static/image/2682.png'),
      idBacksidePhotograph: require('../../../static/image/2683.png'),
      mailingAddress: '邮寄住址',
      PleaseAddress: '请输入您的邮寄地址',
      pleaseWorks: '请上传您的5张作品',
      ihaveRead: '我已经阅读并同意',
      signingAgreement: '签约协议',
      submittedTip: '提交成功，我们会尽快为您审核。审核期间你也可以提交稿件',
      more: '更多',
      organizationCertification: '组织机构认证',
      organizationName: '组织名称',
      pleaseEnterTheOrganizationName: '请输入您的组织名称',
      contactPerson: '真实姓名',
      pleasPerson: '请输入您的真实姓名',
      contactInfo: '联系方式',
      pleasePhoneNumber: '请输入您组织的联系人的电话',
      categoryDescription: '分说明',
      EditPictureDescription: '您可以为这张图片编辑描述',
      editPersonalProfile: '编辑个人资料',
      myWorks: '我的作品',
      myPrizes: '我的获奖',
      myCertificates: '我的证书',
      moreToBeAdded: '暂无更多内容'
    }
  }
}

export default zhcn
